import { gql, useQuery } from "@apollo/client"

export function useLegislation() {
    const { data } = useQuery(gql`
        query legislation {
            legislation {
                HTML
                ScheduleLegislationID
                URL
            }
        }
    `)
    // data can be null (not just undefined) while loading; guard against that
    return data?.legislation ? [...data.legislation] : []
}
